import { Component, OnInit } from '@angular/core';
import { LOGIN_SIGNUP_TEXT, NAV_ITEM } from 'src/app/core/constants/app-constants';
import { Router, RouterState, RouterStateSnapshot, NavigationExtras, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppData, ToastService } from 'src/app/shared';
import { AnalyticsService } from 'src/app/shared/services/analytics.service';
import { CLEVER_TAP_EVENT } from 'src/app/core/constants/clever-tab-event-constants';
import { cartClickedevent } from 'src/app/shared/utils/clever-tab-functions';
import { NavController } from '@ionic/angular';
import { CacheService } from 'src/app/shared/services/cache.service';

@Component({
  selector: 'app-bottom-nav-bar',
  templateUrl: './bottom-nav-bar.component.html',
  styleUrls: ['./bottom-nav-bar.component.scss'],
})
export class BottomNavBarComponent implements OnInit {

  selectedIndex = 0;
  bottomNavList = [];
  itemCount = 0;

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private toast: ToastService,
    private analyticsService: AnalyticsService,
    private navCtrl: NavController,
    private activatedRoute: ActivatedRoute,
    private cacheService: CacheService
  ) {
    this.bottomNavList = NAV_ITEM;

    const state: RouterState = router.routerState;
    const snapshot: RouterStateSnapshot = state.snapshot;

    AppData.bottomNavMobileIndSub$.subscribe(ind => this.selectedIndex = ind);
    // active bottom nav button based on active url
    this.bottomNavList.forEach((obj, ind) => {
      console.log(window.location.pathname, obj.url)
      if (obj.url === window.location.pathname) {
        this.selectedIndex = ind;
        AppData.bottomNavMobileIndSub$.next(this.selectedIndex);
      }
    });

    AppData.plateItemCountSub$.subscribe((res) => {
      console.log(res);
      this.itemCount = res.itemCount;
      if (window.location.pathname === '/explore' && res.itemCount === 0) {
        this.cacheService.toggleFooterNavOnExplore(false)
      }
      if (window.location.pathname === '/explore' && res.itemCount > 0) {
        this.cacheService.toggleFooterNavOnExplore(true)
      }
    });
  }

  async ngOnInit() {
    const state: RouterState = await this.router.routerState;
    const snapshot: RouterStateSnapshot = await state.snapshot;
    console.log(this.router.routerState.snapshot)
    // if (AppData.isTemporary) {
    //   this.bottomNavList[3].name = 'Login';
    // } else {
    //   this.bottomNavList[3].name = 'Account';
    // }
  }

  onItemChange(ind, obj) {
    if (obj.type === 'YOUR_PLATE') {
      if (AppData.yourPlateItems && AppData.yourPlateItems.outlets.length > 0) {
        this.analyticsService.cleverTapEvent(CLEVER_TAP_EVENT.CART_CLICKED, cartClickedevent());
      }
    }
    if (obj.type === 'ACCOUNT') {
      if (AppData.isTemporary) {
        const navigationExtras: NavigationExtras = {
          queryParams: { navigationFrom: 'main', navigateToAccount: true, redirectUrl: window.location.pathname }
        }
        this.navCtrl.navigateForward(['login'], navigationExtras);
      } else {
        this.selectedIndex = ind;
        AppData.bottomNavMobileIndSub$.next(ind);
        this.navigationDir(obj)

        // this.navCtrl.navigateForward([obj.url]);
      }

    } else {
      this.selectedIndex = ind;
      AppData.bottomNavMobileIndSub$.next(ind);
      this.navigationDir(obj)
      // this.navCtrl.navigateForward([obj.url]);
    }
  }
  navigationDir(obj) {
    const clickedNavIndex = this.bottomNavList.findIndex(e => {
      return e.url === obj.url
    })
    const currentNavIndex = this.bottomNavList.findIndex(e => {
      return e.url === window.location.pathname
    })
    if (clickedNavIndex > currentNavIndex) {
      this.navCtrl.navigateForward([obj.url]);
    } else {
      this.navCtrl.navigateBack([obj.url]);
    }
  }

  onImageChange(item, ind) {
    return this.selectedIndex === ind ? item.class : item.class + ' inactive';
  }

}
